export const styles = {
  color: "#414141",
  fontWeight: "normal",
  margin: "6px 7px",
  whiteSpace: "pre-wrap",
};

export const styles1 = {
  text_color: {
    color: "#000000",
    fontWeight: "normal",
    margin: "0px 7px",
  },
};
